import { render, staticRenderFns } from "./PageCheckMail.vue?vue&type=template&id=562e08f7&scoped=true&"
import script from "./PageCheckMail.vue?vue&type=script&lang=js&"
export * from "./PageCheckMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562e08f7",
  null
  
)

export default component.exports